// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-skins-large-badge-350165a2"};